import { Toast, Tooltip } from './_bootstrap';

(function () {
	// * Tooltip initialization, remove it if not necessary
	document
		.querySelectorAll('[data-toggle="tooltip"]')
		.forEach((tooltipElement) => new Tooltip(tooltipElement));

	// * Toast initialization, remove it if not necessary
	document
		.querySelectorAll('.toast')
		.forEach((toastElement) => new Toast(toastElement));

  if (window.innerWidth < 1400) {
    document.getElementById('navigationButton').addEventListener('click', function () {
      if (this.classList.contains('open')) {
        this.classList.remove('open');
        this.setAttribute("aria-expanded", "false");
        document.body.classList.remove('fixed');
      } else {
        this.classList.add('open');
        document.body.classList.add('fixed');
        this.setAttribute("aria-expanded", "true");
      }
    });
  }
})();

